export var Locale;
(function (Locale) {
    Locale["DE"] = "de";
    Locale["EN"] = "en";
})(Locale || (Locale = {}));
